import React, { useState } from "react";
import { useHistory, Route, Redirect } from "react-router-dom";
import  Index  from "../../views/manager/Index";
import CleanNavbar from "components/Navbars/CleanNavbar";
import UserSidebar from "components/Sidebar/UserSidebar";
import ManagerSidebar from "components/Sidebar/ManagerSidebar";
import imgtoData from "../../variables/imgManipulation";
import { getProfileInfo } from "../../network/ApiAxios";
import UserProfile from "views/user/userProfile";
import EditProfile from "views/examples/EditProfile";
import UserDocs from "views/user/UserDocs";
import { Row } from "reactstrap";
import CheckPermission from "variables/CheckPermission";

import ManualTimeClock from "views/examples/schedule/ManualTimeClock";


const Manager = () => {
  const history = useHistory();
  const [pic, setpic] = useState();
  const [permission, setPermission] = useState(true);
  
  const permisson = CheckPermission()
      if(!permisson){
        setPermission(false)
      }
  let user;
  user = JSON.parse(localStorage.getItem("user"));

  // eslint-disable-next-line
  const getProfilePic = async () => {
    const data = await getProfileInfo(user.userID);
    if (data.data.data) {
      const dat = data.data.data;
      setpic(imgtoData(dat));
    } else {
      setpic(require("../../assets/img/theme/team-1-800x800.jpg").default);
    }
  };

  let Comp;
  let title;
  let path = history.location.pathname;
  // eslint-disable-next-line
  switch(path){
      case "/manager/profile":
        Comp=UserProfile;
        title='My Profile';
        break;
      case "/manager/user-profile":
        Comp=UserProfile;
        title='My Profile';
        break;
      case "/manager/index":
        Comp=Index;
        title='My Dashboard';
        break;
      case "/manager/profile/edit":
        Comp=EditProfile;
        title='Edit Profile';
        break;  
      case "/manager/documents":
        Comp=UserDocs;
        title='My Documents';
        break;  
      case "/manager/clockin":
        Comp=ManualTimeClock;
        title='Employee Clock in/Out';
        break;
  }



  return permission ? <>
              
              <ManagerSidebar
              pic={pic}
              logo={{
                innerLink: "/user/index",
                imgSrc: require("../../assets/img/brand/argon-react.png").default,
                imgAlt: "..."
              }}/>
              <div className="main-content">
                <CleanNavbar title={title} />
                <Row className="mb-8"></Row>
                <Route
                component={Comp}
                />
              </div>
          </>: <Redirect to='/' />;
};

export default Manager;
